import { Component, OnInit, Input } from '@angular/core';
import {Project} from "../../models/project";
import {ProjectsService} from "../projects/projects.service";
import {UtilityService} from "../../utility.service";

@Component({
  selector: 'app-project-item',
  templateUrl: './project-item.component.html',
  styleUrls: ['./project-item.component.css']
})
export class ProjectItemComponent implements OnInit {

  @Input() project: Project;
  color: string = '#fff';

  constructor(private utility: UtilityService) { }

  ngOnInit() {
    console.log(this.color);
    this.getRandomColor();
  }

  getRandomColor() {
    this.color = this.utility.getRandomItemBGColor();
  }
}



// WEBPACK FOOTER //
// F:/Home/Locker/About-me/about-me1/src/app/displayer/project-item/project-item.component.ts